import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
const Page = lazy(
  () => import("~/features/sub-orders/order-list/page-client"),
);
export const Route = createFileRoute(
  "/_authed/agent/sub/orders/list",
)({
  component: () => (
    <Suspense fallback={null}>
      <Page />
    </Suspense>
  ),
});
